import React from 'react';

import accordionUtils from './utils';
import { accordionAriaLabels } from 'resources/commonStrings';
import Accordion from '.';
import styles from './Accordion.module.css';
import DataExportScheduler from '../AccordionItems/DataExportScheduler';
import ReportLevelFilter from '../AccordionItems/ReportLevelFilter';
import WhatImDoingFilter from '../AccordionItems/WhatImDoingFilter';

const accordionFactory = (
  accordionDefinition,
  accordionType,
  containingTab,
  onAccordionStateChange,
  sessionToken,
  spaceBetween = true
) => {
  let accordion = null;
  const hideShowText = accordionDefinition.itemState && accordionDefinition.itemState.isExpanded ? 'hide' : 'show';

  switch (accordionType) {
    case accordionUtils.DATA_EXPORT_SCHEDULER: {
      const ariaLabel = accordionAriaLabels.DataExportScheduler(hideShowText);
      accordion = (
        <Accordion
          key={accordionType}
          containingTab={containingTab}
          identifier={accordionType}
          title={accordionDefinition.displayText.toUpperCase()}
          ariaLabel={ariaLabel}
          isExpanded={accordionDefinition.itemState.isExpanded}
          onClick={onAccordionStateChange}
          spaceBetween={spaceBetween}
        >
          <DataExportScheduler
            containingTab={containingTab}
            identifier={accordionType}
            exportHistory={accordionDefinition.itemState.exportHistory}
          />
        </Accordion>
      );

      break;
    }
    case accordionUtils.REPORT_LEVEL_FILTER: {
      const ariaLabel = accordionAriaLabels.ReportLevelFilter(hideShowText);
      accordion = (
        <Accordion
          key={accordionType}
          containingTab={containingTab}
          identifier={accordionType}
          title={accordionDefinition.displayText}
          ariaLabel={ariaLabel}
          isExpanded={accordionDefinition.itemState.isExpanded}
          onClick={onAccordionStateChange}
          spaceBetween={spaceBetween}
          additionalClasses={styles['level-filter']}
        >
          <ReportLevelFilter
            containingTab={containingTab}
            identifier={accordionType}
            value={accordionDefinition.itemState.value}
            roleLevel={accordionDefinition.itemState.roleLevel}
            onAccordionStateChange={onAccordionStateChange}
            mutuallyExclusiveFilterState={accordionDefinition.mutuallyExclusiveFilterState}
            allReportDetails={accordionDefinition.allReportDetails}
            sortingMethod={accordionDefinition.sortingMethod}
          />
        </Accordion>
      );
      break;
    }
    case accordionUtils.WHAT_IM_DOING_FILTER: {
      const ariaLabel = accordionAriaLabels.WhatImDoingFilter(hideShowText);
      accordion = (
        <Accordion
          key={accordionType}
          containingTab={containingTab}
          identifier={accordionType}
          title={accordionDefinition.displayText}
          ariaLabel={ariaLabel}
          isExpanded={accordionDefinition.itemState.isExpanded}
          onClick={onAccordionStateChange}
          spaceBetween={spaceBetween}
          additionalClasses={styles['what-im-doing-filter']}
        >
          <WhatImDoingFilter
            containingTab={containingTab}
            identifier={accordionType}
            value={accordionDefinition.itemState.value}
            onAccordionStateChange={onAccordionStateChange}
            mutuallyExclusiveFilterState={accordionDefinition.mutuallyExclusiveFilterState}
            allReportDetails={accordionDefinition.allReportDetails}
            sortingMethod={accordionDefinition.sortingMethod}
          />
        </Accordion>
      );
      break;
    }
    default: {
      console.warn(`An unknown accordion type '${accordionType}' was specified, it cannot be created`);
    }
  }

  return accordion;
};

export default accordionFactory;
